export const passwordProtected = () => {
  const passwordContent = document.querySelector(
    '.et_password_protected_form p',
  );
  const formButton = document.querySelector(
    '.et_password_protected_form .et_submit_button',
  );

  if (passwordContent) {
    passwordContent.innerHTML =
      '<strong>This content is password protected. To view it please enter your password below:</strong>';
  }

  if (formButton) {
    formButton.innerHTML = 'ENTER';
  }
};
